export default "__VITE_ASSET__CXWtOPOZ__"